<template lang="pug">
.notification-wrapper(:class="{ 'apiMarquee': whiteLabel }")
  span.icon
    i.fas.fa-bell
  .marquee-parent
    marquee.marquee-child(v-if="marqueeList.length >= 1" behavior="scroll" direction="left" scrollamount="5") {{ marqueeList[0]["msg_" + language] }}
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import service from "@/library/_xhr-message";

export default {
  data() {
    return {
      marqueeList: [],
      feedback: {
        success: false,
        status: errors.session.invalidSession
      }
    }
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    language() {
      return this.$store.getters.language;
    },
  },
  mounted() {
    this.runner();
    setInterval(this.runner, 60000);
  },
  methods: {
    runner() {
      this.getMarqueeList();
    },
    getMarqueeList() {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken
      };
      this.loading = true;
      service.getMarqueeList(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.marqueeList = result.data;
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    }
  }
}
</script>